module.exports = __webpack_public_path__ + "media/images/close-call-f36eb4f8.svg";